// Environment detection helper
export const isProduction = () => {
  // Check if we're in production environment
  const hostname = window.location.hostname;
  const isProdDomain = hostname === 'www.coachingsearchengine.com' || hostname === 'coachingsearchengine.com';
  const isProdBuild = process.env.NODE_ENV === 'production';

  return isProdDomain && isProdBuild;
};

export const isDevelopment = () => {
  return !isProduction();
};

export const getCurrentEnvironment = () => {
  return isProduction() ? 'production' : 'development';
};

// Domain check functions
export const isDevDomain = () => {
  const hostname = window.location.hostname;
  return hostname.includes('dev.coachingsearchengine.com') || hostname === 'localhost';
};

export const isProdDomain = () => {
  const hostname = window.location.hostname;
  return hostname === 'www.coachingsearchengine.com' || hostname === 'coachingsearchengine.com';
};
